var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { connect } from 'react-redux';
import { mapValues, reduce, get, map, assign, set, defaults } from 'lodash';
import { actions } from '@comall-backend-builder/core';
import { Form } from '../form';

function mapStateToProps(_state, props) {
  var entity = props.entity,
      fieldsFromProps = props.fields,
      mode = props.mode;
  var submit = props.submit;
  var entityId = entity.id,
      entityFilters = entity.metainfo.filters;
  var fieldValues = entity.filters || {};
  var filters = {};
  map(fieldsFromProps, function (field) {
    var property = field.property,
        config = __rest(field, ["property"]); // 从实体中获取属性配置，实体中的 path 为 style.properties.color，配置中 path 为 style.color


    var entityProperty = get(entityFilters, property.replace(/\./g, '.properties.'));

    if (entityProperty) {
      set(filters, property, assign({}, entityProperty, config));
    } else {
      throw new Error("Property " + property + " not found in Entity " + entityId);
    }
  });
  var fields = mapValues(filters, function (config, name) {
    var field = __assign({}, config);

    field.value = get(fieldValues, name);
    return field;
  });

  if (!submit || mode === 'change') {
    submit = false;
  }

  return {
    state: {
      fields: fields
    },
    fieldSource: 'filters',
    submit: submit
  };
}

function mapDispatchToProps(dispatch, props) {
  var entity = props.entity,
      submit = props.submit,
      mode = props.mode,
      fieldsFromProps = props.fields,
      resetPagination = props.resetPagination,
      onInit = props.onInit,
      onSubmit = props.onSubmit,
      onReset = props.onReset;

  var handleInit = function handleInit() {
    var entityId = entity.id,
        entityFilters = entity.metainfo.filters;
    var filters = {};
    map(fieldsFromProps, function (field) {
      var property = field.property,
          config = __rest(field, ["property"]); // 从实体中获取属性配置，实体中的 path 为 style.properties.color，配置中 path 为 style.color


      var entityProperty = get(entityFilters, property.replace(/\./g, '.properties.'));

      if (entityProperty) {
        set(filters, property, assign({}, entityProperty, config));
      } else {
        throw new Error("Property " + property + " not found in Entity " + entityId);
      }
    }); //如果存在缓存数据则直接按照已缓存的请求进行初始化

    var defaultFilters = reduce(filters, function (result, filter, key) {
      if (filter.defaultValue !== undefined) {
        result[key] = filter.defaultValue;
      }

      return result;
    }, {});
    dispatch(actions.filtersChangeAction(entity, defaultFilters));
  };

  return defaults({
    onInit: onInit,
    onSubmit: onSubmit,
    onReset: onReset
  }, {
    onInit: function onInit() {
      if (!entity.filters) {
        handleInit();
      }
    },
    // 表单域改变
    onFieldChange: function onFieldChange(name, value) {
      var _a;

      var fields = Object.assign({}, entity.filters, (_a = {}, _a[name] = value, _a));
      entity.filtersChange(fields);

      if (mode === 'change') {
        if (resetPagination !== false) {
          entity.pageChange(Object.assign({}, entity.paging, {
            page: 1
          }));
        }

        entity.search(props.params);
      }
    },
    // 提交表单
    onSubmit: function onSubmit(event) {
      if (event) {
        event.stopPropagation();
      }

      if (!!submit) {
        if (resetPagination !== false) {
          entity.pageChange(Object.assign({}, entity.paging, {
            page: 1
          }));
        }

        entity.search(props.params);
      }
    },
    onReset: handleInit
  });
}

export var FilterForm = connect(mapStateToProps, mapDispatchToProps)(Form);